import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { parseToUnit } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { StageType } from '@meitu/saas-editor-core/es/version-types';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

const CanvasSize: React.FC<{
    imageEditorStyle: boolean;
    handler: () => void;
    currentWidth: number;
    currentHeight: number;
}> = React.memo(({ handler, imageEditorStyle = false, currentWidth, currentHeight }) => {
    const { $t } = useLocaleStore();
    // 图片编辑隐藏功能
    imageEditorStyle && (handler = () => {});
    const [isPickStage, setIsPickStage] = useState(editor.stage.isPick());
    const { width: totalWidth, height: totalHeight } = editor.stage.getSize();
    const stageType = editor.stage.getType();
    const isShowCurrentSize = isPickStage || stageType !== StageType.VARIETY;
    const unit = editor.stage.getUnit();

    useEffect(() => {
        const handle = editor.stage.onPickChange((isPickStage) => {
            setIsPickStage(isPickStage);
        });
        return () => {
            editor.off(handle);
        };
    }, []);

    return (
        <React.Fragment>
            <div
                className={classNames('c-background-panel__size', {
                    disabled: imageEditorStyle,
                })}
            >
                <div className="c-background-panel__size-item" onClick={handler}>
                    <span className="c-background-panel__size-value ellipsis">
                        {parseToUnit(isShowCurrentSize ? currentWidth : totalWidth, unit)}
                        {unit}
                    </span>
                    <span className="c-background-panel__size-label">{$t((v) => v.panel.backgroundPanel.width)}</span>
                </div>
                <div className="c-background-panel__size-item" onClick={handler}>
                    <span className="c-background-panel__size-value ellipsis">
                        {parseToUnit(isShowCurrentSize ? currentHeight : totalHeight, unit)}
                        {unit}
                    </span>
                    <span className="c-background-panel__size-label">{$t((v) => v.panel.backgroundPanel.height)}</span>
                </div>
            </div>
        </React.Fragment>
    );
});

export default CanvasSize;
